export enum AccountExceptions {
  EXISTING_USER = 'ExistingUserException'
}
